"use client";

import Link from "next/link";
import { Phone, MessageSquare } from "lucide-react";
import { SITE } from "@/lib/siteData";

export default function StickyBottomBar() {
  return (
    <nav aria-label="Quick contact" className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[#FFFFFF]/95 backdrop-blur-md border-t border-stone-200 px-3 py-2 safe-area-pb">
      <div className="flex items-center gap-2">
        {/* Primary CTA — Phone call with premium gradient */}
        <a
          href={SITE.phoneHref}
          aria-label={`Call now — Eagle Chimney Service ${SITE.phone}`}
          className="flex-[1.3] flex items-center justify-center gap-2 cta-gold cta-pulse text-[#0A0A0A] font-bold py-3.5 rounded-full min-h-[52px] text-base shadow-lg shadow-[#E8BD4E]/30"
        >
          <Phone className="h-5 w-5" aria-hidden="true" />
          Call Now
        </a>
        {/* Secondary CTA — send a message via contact form */}
        <Link
          href="/contact"
          aria-label="Send us a message about your chimney or fireplace"
          className="flex-1 flex items-center justify-center gap-2 bg-[#EEE9DD] hover:bg-[#E5DFD0] active:bg-[#DDD5C2] text-[#0A0A0A] font-bold py-3.5 rounded-full transition-colors min-h-[52px] text-base border border-stone-300"
        >
          <MessageSquare className="h-5 w-5" aria-hidden="true" />
          Message
        </Link>
      </div>
    </nav>
  );
}
